export class ProductionColumn {
  public id: string | number;
  public label: any | number;
  public highlight: boolean;
  public isToday: boolean;
  public isWeekend: boolean;

  constructor(
    id: string | number,
    label: string | number,
    isToday: boolean,
    isWeekend = false,
  ) {
    this.id = id;
    this.label = label;
    this.isToday = isToday;
    this.highlight = false;
    this.isWeekend = isWeekend;
  }
}
